import {AlertDefaultProps, AlertDetailedProps} from '../Alert/Alert';
import {NOTIFICATION_POSITIONS} from './Notification.constants';

export type NotificationConfigBase = {
  id?: string;
  autoClose?: boolean | number;
  onClose?(props: NotificationProps): void;
  onOpen?(props: NotificationProps): void;
};

export type NotificationProps =
  | (NotificationConfigBase & Omit<AlertDefaultProps, 'onClose'>)
  | (NotificationConfigBase & Omit<AlertDetailedProps, 'onClose'>);

export interface NotificationsContextProps {
  notifications: NotificationProps[];
  queue: NotificationProps[];
  showNotification(props: NotificationProps): string;
  updateNotification(id: string, props: Partial<NotificationProps>): void;
  hideNotification(id: string): void;
  clean(): void;
  cleanQueue(): void;
}

export type Positions = (typeof NOTIFICATION_POSITIONS)[number];
